import PropTypes from "prop-types";
import SettingsField from "./SettingsField";
import SettingsSection from "./SettingsSection";
import { fieldId, MAX_CAP } from "./settingsForm";
import { MUSCLES, REGIONS } from "../lib/format";

/** Per muscle: an optional ceiling on weekly sets (0–40; blank = none). */
function CapsSection({ caps, onChange, errorFor }) {
  return (
    <SettingsSection
      id="training-settings-caps"
      title="Weekly caps"
      error={errorFor("target_caps") || undefined}
      description={
        <>
          <p>
            A ceiling on a muscle&apos;s weekly sets (work where it&apos;s a secondary muscle
            counts half). Its target never rises past your cap, even when it recovers well — and
            a cap below the usual starting point wins.
          </p>
          <p>Leave it blank for no cap of yours: the target still stays within what you can recover from.</p>
        </>
      }
    >
      {REGIONS.map((region) => {
        const muscles = MUSCLES.filter((m) => m.region === region.code);
        if (muscles.length === 0) return null;
        return (
          <div key={region.code} className="flex flex-col gap-2">
            <h3 className="m-0 text-xs font-semibold tracking-wide text-muted-foreground uppercase">
              {region.label}
            </h3>
            {/* Each field takes three row tracks (label, input, error) of
                this grid — `subgrid` — so a two-line label ("Rotator cuff &
                scapular stabilisers") leaves its row's inputs in line. The
                6 px row gap twice (around an empty error track) keeps rows
                12 px apart. */}
            <div className="grid grid-cols-2 gap-x-3 gap-y-1.5 sm:grid-cols-3">
              {muscles.map((muscle) => {
                const path = `target_caps.${muscle.code}`;
                return (
                  <SettingsField
                    key={muscle.code}
                    subgrid
                    id={fieldId(path)}
                    label={
                      <>
                        {muscle.label}
                        <span className="sr-only"> weekly cap</span>
                      </>
                    }
                    value={caps[muscle.code]}
                    onChange={(value) => onChange({ ...caps, [muscle.code]: value })}
                    inputMode="numeric"
                    unit="sets"
                    placeholder="none"
                    error={errorFor(path) || undefined}
                  />
                );
              })}
            </div>
          </div>
        );
      })}
      <p className="m-0 text-xs text-muted-foreground">Whole sets from 0 to {MAX_CAP}.</p>
    </SettingsSection>
  );
}

CapsSection.propTypes = {
  caps: PropTypes.objectOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
  errorFor: PropTypes.func.isRequired,
};

export default CapsSection;
